import { render, staticRenderFns } from "./DailyBoxDelete.vue?vue&type=template&id=14a10874"
import script from "./DailyBoxDelete.vue?vue&type=script&lang=js"
export * from "./DailyBoxDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports